import React from 'react';
import { Link } from 'react-router';

export default function Footer() {
  const linkStyle = { color: '#64748b', textDecoration: 'none' };
  return (
    <footer
      style={{
        background: '#0f1923',
        borderTop: '1px solid #1e3a5f',
        padding: '14px 24px',
        textAlign: 'center',
        color: '#94a3b8',
        fontSize: 12,
        flexShrink: 0,
      }}
    >
      <div>
        <span style={{ color: '#f43f5e', fontWeight: 600 }}>CrimsonScan</span>
        <span style={{ color: '#475569', margin: '0 6px' }}>·</span>
        <span style={{ color: '#94a3b8' }}>Spectra</span>
        <span style={{ color: '#475569', margin: '0 8px' }}>|</span>
        <span style={{ color: '#64748b' }}>MatterGen · IBM FM4M · GT4SD · pymatgen</span>
      </div>
      <div style={{ marginTop: 6, display: 'inline-flex', gap: 16 }}>
        <Link to="/docs/privacy" style={linkStyle}>Privacy Policy</Link>
        <Link to="/docs/acceptable-use" style={linkStyle}>Acceptable Use</Link>
      </div>
    </footer>
  );
}
